class Controller {
  constructor(Events) {
    "ngInject";

    this.paginateEvent = Events.getPaginateEvent("bulkInvoiceItemTypesUploads");
    this.resourceParams = {
      isCityRequired: false,
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploads/bulkInvoiceItemTypesUploads.controller.js